<template>
  <v-data-table
  :items-per-page="-1"
  hide-default-footer
  :items="entries"
  :headers="aggregateHeaders"
  @click:row="onRowClick">
    <template #item.amount="{item}">
      <span>{{ formatMoney(item.amount) }}</span>
    </template>
  </v-data-table>
</template>

<script>
import { formatMoney } from '@/utils/NumericMutations'
import AdjustingEntriesHeaders from '@/headers/AdjustingEntries.js'
export default {
  name: 'BasicFinancialTable',

  props: {
    entries: {
      type: Array,
      required: true
    }
  },

  computed: {
    aggregateHeaders () {
      return AdjustingEntriesHeaders.miscPayments()
    }
  },

  methods: {
    formatMoney,
    selection (item) {
      this.$emit('aggregate-selected', item)
    },

    onRowClick (item) {
      this.selection(item)
    }
  }
}
</script>
